export function handleSubscriptionResponse(ele: any, tosterService: any): void {
  const showMessage = (type: 'success' | 'error' | 'info', message: string) => {
    tosterService[type](message, '',{timeOut: 4000});
    console.warn(
      `API Message: ${ele.message}, Response Code: ${ele?.data?.responseCode}`
    );
  };

  let messageType: 'success' | 'error' | 'info' = ele.status
    ? 'success'
    : 'error';

  switch (ele.message) {
    case 'downgradeNotAllow':
      showMessage(
        messageType,
        'You cannot downgrade from a higher to a lower subscription'
      );
      break;

    case 'planChangeNotAllow':
      showMessage(
        messageType,
        'Changing from daily to monthly plan is not allowed'
      );
      break;

    case 'bundleAlreadyExist':
      showMessage(
        messageType === 'success' ? 'success' : 'info',
        'Bundle is already active'
      );
      break;

    case 'categoryExistForOtherBundle':
      showMessage(messageType, 'Category already exists in another bundle');
      break;

    case 'choseCategory':
      showMessage(
        messageType,
        'You already have an active subscription for this category'
      );
      break;

    case 'dependentNotAllow':
      showMessage(messageType, 'Dependents cannot subscribe or unsubscribe');
      break;

    case 'categoryAlreadyActive':
      showMessage(
        messageType === 'success' ? 'success' : 'info',
        'Category is already active'
      );
      break;

    case 'ActivationRequestSubmit':
      showMessage('success', 'Activation request submitted successfully');
      break;

    default:
      let message =
        ele.message ||
        (ele.status
          ? 'Subscription successful'
          : 'Subscription failed. Please try again');

      switch (ele?.data?.responseCode) {
        case '99033':
          // User's mobile number is not registered with EcoCash.
          // Prompt them to use a registered number or sign up.
          messageType = 'error';
          message ='Payment failed';
          break;

        case '20005':
          // User's account is currently blocked.
          // Suggest resetting the PIN or contacting support.
          message =
            'Your account is currently blocked. Please reset your pin or contact customer care for help.';
          break;

        case '20001':
          // Mobile number or PIN entered is invalid.
          // Inform the user to double-check credentials.
          message = 'Invalid mobile number or pin. Please check and try again';
          break;

        case '20006':
          // Wrong PIN entered, and user is near account lock.
          // Warn about one more incorrect attempt.
          message =
            'Incorrect pin entered. One more failed attempt may block your account.';
          break;

        case '32012':
          // User didn’t enter a proper PIN.
          // Ask to enter a valid 4-digit PIN.
          message = 'Please enter a valid 4-digit pin to proceed.';
          break;

        case '002100':
          // General or unknown error
          // Show the original message from API instead of static text
          message = ele.message;
          break;

        case '00':
          // Success response code.
          // PIN was verified successfully.
          message = 'Your pin has been successfully verified.';
          break;

        default:
          // Handle unknown responseCode with fallback
          message =
            ele.message || 'Unexpected error occurred. Please contact support.';
          break;
      }

      showMessage(messageType, message);
      break;
  }
}
